<mat-sidenav-container class="sidenav-container body-1-regular-2">
  <!-- Right sidenav -->
  <mat-sidenav #rightSidenav mode="side" position="end" class="sidenav-right"
               [fixedInViewport]="false" [fixedTopGap]="0"
               [fixedBottomGap]="0">

    <div class="sidenav-right-content" fxLayout="column" fxFlex="220px">

      <!-- Embed into site -->
      <div class="py-3" fxLayout="column" fxLayoutAlign="center start" fxLayoutGap="10px">
        <span class="heading-regular">Embed into your site</span>
        <div class="heading-bold px-3" fxFlexOffset="15px">
          Directly embed the active form onto your site. This way it will appear in the middle of your webpage.
        </div>
        <span class="body-1-regular-2 px-3" fxFlexOffset="15px">How to embed the form</span>


        <div class="stepper pt-3" fxLayout="column" fxLayoutAlign="center start" fxLayoutGap="20px">
          <div class="step" fxLayout="row" fxLayoutAlign="center start">
            <div class="dot">1</div>
            <div class="label">Identify the webpage where you want to add your form</div>
          </div>
          <div class="line"></div>
          <div class="step" fxLayout="row" fxLayoutAlign="center start">
            <div class="dot">2</div>
            <div class="label">Style and copy your active form source code</div>
          </div>
          <div class="line"></div>
          <div class="step" fxLayout="row" fxLayoutAlign="center start">
            <div class="dot">3</div>
            <div class="label">Add the HTML source code to your webpage</div>
          </div>
        </div>
      </div>

      <div class="fx-col-w-100 fx-gap-10">
        <span class="heading-regular">Embeddable source code</span>

        <button (click)="copyEmbedCode()" class="button-primary fx-center" style="width: 200px"style="width: 200px" mat-button>
          <div class="button-text">Copy code</div>
        </button>
      </div>


      <!-- QR code form -->
      <div class="py-3" fxLayout="column" fxLayoutAlign="center start" fxLayoutGap="10px">
        <span class="heading-regular">QR code</span>

        <mat-tab-group class="full-width">
          <mat-tab label="Form" >
            <div class="fx-col-w-100 fx-v-center pt-3">
              <img [src]="qrCodeImageSrc" class="application-qr-code" alt="QR Code">
              <div class="fx-row fx-gap-10 fx-center fx-h-center">
                <button (click)="downloadQRCodeImage()" class="button-primary" style="width: 150px"
                        mat-button [disabled]="!qrCodeImageSrc">
                  <div class="button-text">Download</div>
                </button>
                <button (click)="copyHostedFormLink()" mat-icon-button color="primary"
                        matTooltip="Copy link to clipboard">
                  <mat-icon class="material-icons-outlined">content_copy</mat-icon>
                </button>
              </div>

            </div>
          </mat-tab>
          <mat-tab label="Custom">
              <div class="fx-col-w-100 fx-v-center pt-3 fx-gap-20">
                <span class="heading-regular">Custom QR code link</span>
                <div>Enter a custom URL for the QR code to open when it is scanned. This allows you to
                have prospective tenants land on a branded or custom page where the application for has been
                embedded instead of loading the application form directly in a web browser</div>

                <mat-form-field class="custom-text-field embed-input" appearance="outline">
                  <input type="text" matInput [(ngModel)]="qrCodeUrl">
                  <mat-icon matSuffix
                            matTooltip="Test link"
                            (click)="testExternalUrl()">
                    link
                  </mat-icon>
                </mat-form-field>
                <div class="fx-row-w-100 fx-h-center fx-v-center fx-gap-20">
                <button class="button-primary full-width" mat-button
                        (click)="updateQrCodeUrl()"
                        [disabled]="!canUpdateCustomUQrUrl">
                  <div class="button-text">Update</div>
                </button>
                <button  class="button-secondary full-width" mat-flat-button
                         (click)="removeCustomUrl()"
                         [disabled]="!qrCodeUrlFromContext">
                  <div class="button-text">Remove</div>
                </button>
                </div>

                <mat-divider class="full-width"></mat-divider>

                <span class="heading-regular">Redirect after submission</span>
                <div>Enter a URL to send applicants to your own page, such as a thank-you page, after they submit the
                  application form, whether on your website or through the QR code or hosted link. They see a 10 second
                  countdown before being redirected. Remove the link to stop redirecting.</div>

                <mat-form-field class="custom-text-field embed-input" appearance="outline">
                  <input type="url" matInput [formControl]="redirectUrl" aria-label="Redirect URL"
                         placeholder="https://www.example.com/thank-you">
                  @if (redirectUrlError) {
                    <mat-error class="link-error">{{ redirectUrlError }}</mat-error>
                  }
                </mat-form-field>
                <div class="fx-row-w-100 fx-h-center fx-v-center fx-gap-20" data-testid="app-form-redirect">
                  <button class="button-primary full-width" mat-button
                          (click)="updateApplicationFormRedirect()"
                          [disabled]="!canUpdateApplicationFormRedirect">
                    <div class="button-text">Save</div>
                  </button>
                  <button class="button-secondary full-width" mat-flat-button
                          (click)="removeApplicationFormRedirect()"
                          [disabled]="!redirectUrlFromContext">
                    <div class="button-text">Remove</div>
                  </button>
                </div>
              </div>
          </mat-tab>
        </mat-tab-group>
      </div>
    </div>

  </mat-sidenav>

  <!-- Main content -->
  <mat-sidenav-content cdkScrollable class="sidenav-main-content" >
    <div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="15px">

      <!-- Page header -->
      <app-page-header [section]="'Application Forms'"
        [title]="'Create custom application forms'"
        [description]="'Create and update custom forms that integrates with your applications\n'+
                      'module. Retailers can apply to your retail space with this form.'">
      </app-page-header>

      <!-- Main content area -->
        <div class="content-padding" fxLayout="row" fxLayoutAlign="space-between center">
          <div class="subtitle-default">Application forms</div>
          <button (click)="startNewApplication()" class="button-outline-white" mat-flat-button style="width: 200px">
            <div class="button-text">Create a new application</div>
          </button>
        </div>

        <div class="content-padding">
          <div class="table-card mat-elevation-z3"  fxLayout="column">

            <table [dataSource]="dataSource" class="custom-table-form" fxFlexOffset="25px" mat-table>
              <ng-container matColumnDef="formName">
                <th *matHeaderCellDef mat-header-cell class="custom-th">Name</th>
                <td *matCellDef="let element" class="custom-table-cell" mat-cell>{{element.formName}}</td>
                <td *matFooterCellDef [class.hidden-footer-cell]="dataSource.data.length > 0" mat-footer-cell>
                  <button (click)="startNewApplication()" *ngIf="dataSource.data.length == 0" class="button-outline-white" mat-flat-button style="width: 200px">
                    <div class="button-text">Create a new application</div>
                  </button>
                </td>
              </ng-container>

              <ng-container matColumnDef="isCurrentlyActive">
                <th *matHeaderCellDef mat-header-cell class="custom-th">Status</th>
                <td *matCellDef="let element" class="custom-table-cell" mat-cell>
                  <div *ngIf="element.isCurrentlyActive" class="success-chip" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                    <mat-icon>check_circle</mat-icon>
                    <span class="footer-default">Active</span>
                  </div>
                <td *matFooterCellDef [class.hidden-footer-cell]="dataSource.data.length > 0" mat-footer-cell></td>
              </ng-container>

              <ng-container matColumnDef="updateDate">
                <th *matHeaderCellDef mat-header-cell class="custom-th">Last edited</th>
                <td *matCellDef="let element" class="custom-table-cell"
                    mat-cell>{{dateUtils.displayShortDate(element.updateDate)}}</td>
                <td *matFooterCellDef [class.hidden-footer-cell]="dataSource.data.length > 0" mat-footer-cell></td>
              </ng-container>

              <ng-container matColumnDef="preview">
                <th *matHeaderCellDef mat-header-cell style="text-align: center" class="custom-th">Preview</th>
                <td *matCellDef="let element" class="custom-table-cell" mat-cell style="text-align: center">
                  <div class="form-hover-button" fxLayout="row" fxLayoutAlign="center center">
                    <button (click)="previewForm(element)" class="form-icon-button" mat-icon-button>
                      <mat-icon class="material-icons-outlined">visibility</mat-icon>
                    </button>

                  </div>
                </td>
                <td *matFooterCellDef [class.hidden-footer-cell]="dataSource.data.length > 0" mat-footer-cell></td>
              </ng-container>

              <ng-container matColumnDef="makeActive">
                <th *matHeaderCellDef mat-header-cell style="text-align: center" class="custom-th">Make Active</th>
                <td *matCellDef="let element" class="custom-table-cell" mat-cell style="text-align: center">
                  <div class="form-hover-button" fxLayout="row" fxLayoutAlign="center center">
                    <button (click)="setAsActiveFormTemplate(element)" class="form-icon-button" mat-icon-button>
                      <mat-icon class="material-icons-outlined">done</mat-icon>
                    </button>

                    <div class="form-button-tooltip">
                      <span class="body-1-default tooltip-text">Make this form your set offering application.</span>
                    </div>
                  </div>
                </td>
                <td *matFooterCellDef [class.hidden-footer-cell]="dataSource.data.length > 0" mat-footer-cell></td>
              </ng-container>

              <ng-container matColumnDef="edit">
                <th *matHeaderCellDef mat-header-cell style="text-align: center" class="custom-th">Edit</th>
                <td *matCellDef="let element" class="custom-table-cell" mat-cell style="text-align: center">

                  <div class="form-hover-button" fxLayout="row" fxLayoutAlign="center center">
                    <button (click)="editExistingApplication(element)" class="form-icon-button" mat-icon-button>
                      <mat-icon class="material-icons-outlined">edit</mat-icon>
                    </button>

                    <div class="form-button-tooltip" *ngIf="!canBeUpdated(element)">
                      <span class="body-1-default tooltip-text">Forms that have been used cannot be edited</span>
                    </div>
                  </div>
                </td>
                <td *matFooterCellDef [class.hidden-footer-cell]="dataSource.data.length > 0" mat-footer-cell></td>
              </ng-container>

              <ng-container matColumnDef="duplicate">
                <th *matHeaderCellDef mat-header-cell style="text-align: center" class="custom-th">Duplicate</th>
                <td *matCellDef="let element" class="custom-table-cell" mat-cell style="text-align: center">
                  <div class="form-hover-button" fxLayout="row" fxLayoutAlign="center center">
                    <button (click)="duplicateForm(element)" class="form-icon-button" mat-icon-button>
                      <mat-icon class="material-icons-outlined">content_copy</mat-icon>
                    </button>

                    <div class="form-button-tooltip">
                      <span class="body-1-default tooltip-text">This will create a new form version to edit.</span>
                    </div>
                  </div>
                </td>
                <td *matFooterCellDef [class.hidden-footer-cell]="dataSource.data.length > 0" mat-footer-cell></td>
              </ng-container>

              <ng-container matColumnDef="delete">
                <th *matHeaderCellDef mat-header-cell style="text-align: center" class="custom-th">Delete</th>
                <td *matCellDef="let element" class="custom-table-cell" mat-cell style="text-align: center">
                  <div class="form-hover-button" fxLayout="row" fxLayoutAlign="center center">
                    <button (click)="deleteFormTemplate(element)" class="form-icon-button" mat-icon-button>
                      <mat-icon class="material-icons-outlined">delete</mat-icon>
                    </button>

                    <div class="form-button-tooltip">
                      <span class="body-1-default tooltip-text">This will delete the form permanently.</span>
                    </div>
                  </div>
                </td>
                <td *matFooterCellDef [class.hidden-footer-cell]="dataSource.data.length > 0" mat-footer-cell></td>
              </ng-container>

              <tr *matHeaderRowDef="displayedColumns" class="custom-table-header" mat-header-row></tr>
              <tr *matRowDef="let row; columns: displayedColumns;" class="custom-table-row" mat-row></tr>
              <tr *matFooterRowDef="displayedColumns" [class.hidden-footer-row]="dataSource.data.length > 0" mat-footer-row></tr>
            </table>
          </div>
        </div>
    </div>
  </mat-sidenav-content>

</mat-sidenav-container>
